import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	TableCell,
	TableRow,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import { chronos } from "nhb-toolbox";
import React from "react";
import TableActions from "src/common/TableActions";
import Label from "src/components/Label";
import { getFormattedCurrency } from "src/Helpers/utils";
import { useApiMutation } from "src/hooks/useApiMutation";
import { IPayableItem } from "src/Types/module/paymentableItem/itemList";
import UpdatePayableItem from "../UpdatePaymentable/Index";

export interface Props {
	payableItem: IPayableItem;
	index: number;
}

const PayableItemTableRow = ({ payableItem, index }: Props) => {
	const theme = useTheme();

	const { mutate: deleteItem, isPending } = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/admin/payment-items/${payableItem.id}`,
		invalidateQueries: ["PayableItems"],
	});

	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

	// Update Functions
	const [openUpdate, setOpenUpdate] = React.useState(false);

	const handleClickOpenUpdate = () => {
		setOpenUpdate(true);
	};

	const handleCloseUpdate = () => {
		setOpenUpdate(false);
	};

	return (
		<>
			<TableRow hover>
				<TableCell>{index + 1}</TableCell>
				<TableCell>{payableItem.name}</TableCell>
				<TableCell>
					{getFormattedCurrency(payableItem.amount)}
				</TableCell>
				<TableCell>
					{getFormattedCurrency(payableItem.discount)}
				</TableCell>
				<TableCell>
					{chronos(payableItem.created_at).formatStrict(
						"dd, mmm Do, yy; hh:mm:ss A"
					)}
				</TableCell>
				<TableCell>{payableItem?.type?.toUpperCase()}</TableCell>
				<TableCell>{payableItem.created_by}</TableCell>
				<TableCell>
					<Label color={payableItem.status ? "success" : "warning"}>
						{payableItem.status ? "Active" : "Inactive"}
					</Label>
				</TableCell>

				<TableActions
					showEdit
					handleEditFun={handleClickOpenUpdate}
					showDelete
					handleDeleteFun={deleteItem}
					loading={isPending}
				/>
			</TableRow>

			{/* Modal */}
			<Dialog
				fullScreen={fullScreen}
				open={openUpdate}
				maxWidth="md"
				onClose={handleCloseUpdate}
				aria-labelledby="responsive-dialog-title"
			>
				<DialogContent>
					<Box sx={{ mb: 2 }}>
						<Typography sx={{ mb: 2 }}>
							Update Item: {payableItem.name}
						</Typography>
					</Box>
					<UpdatePayableItem
						payableItem={payableItem}
						handleClose={handleCloseUpdate}
					/>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleCloseUpdate}>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default PayableItemTableRow;
